import { TagList } from '@/types/article';
import { HashIcon } from '../Icon/illustration/HashIcon';

export const Tag: React.FC<{
  as?: 'a' | 'span';
  href?: string;
  name?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
}> = ({ as = 'span', name, children, ariaLabel, ...props }) => {
  const Component = as;
  const classNames = `border-primary bg-neutral text-dark-200 flex items-center justify-center rounded-[6px] border-2 bg-gray-200 p-3 align-middle text-sm text-gray-700 ${as === 'a' ? 'hover:bg-neutral-400 cursor-pointer' : 'cursor-default'}`;

  return (
    <Component className={classNames} {...props}>
      <span className={name ? 'mr-3' : ''} aria-label={ariaLabel}>
        {children}
      </span>
      {name}
    </Component>
  );
};

export const Tags = ({ tags }: { tags: TagList }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div className="mt-12 mb-6">
      <div className="flex flex-wrap gap-2">
        <p className="w-full font-bold">Related tags:</p>
        {tags
          .filter((t) => !!t.tag?.value?.name)
          .map(({ tag }) => (
            <Tag key={tag!.value!.name!} name={tag!.value!.name!}>
              <HashIcon width={14} height={14} style={{ marginTop: -2 }} />
            </Tag>
          ))}
      </div>
    </div>
  );
};
